// Static interface copy in every supported app language. User and model content is not translated here.
import type { NamespaceCatalog } from '@/i18n/ns';

const en = {
  loading: 'Loading your Apps…',
};

export type AppsLoadingCopyKey = keyof typeof en;

const copy: NamespaceCatalog<keyof typeof en> = {
  bg: {
    loading: 'Зареждане на вашите приложения…',
  },
  hr: {
    loading: 'Učitavanje vaših aplikacija…',
  },
  cs: {
    loading: 'Načítání vašich aplikací…',
  },
  da: {
    loading: 'Indlæser dine apps…',
  },
  nl: {
    loading: 'Je Apps worden geladen…',
  },
  en: {
    loading: 'Loading your Apps…',
  },
  et: {
    loading: 'Teie rakendusi laaditakse…',
  },
  fi: {
    loading: 'Sovelluksia ladataan…',
  },
  fr: {
    loading: 'Chargement de vos applications…',
  },
  de: {
    loading: 'Ihre Apps werden geladen…',
  },
  el: {
    loading: 'Φόρτωση των Εφαρμογών σας…',
  },
  hu: {
    loading: 'Az alkalmazások betöltése…',
  },
  ga: {
    loading: 'Aipeanna á lódáil…',
  },
  it: {
    loading: 'Caricamento delle tue app…',
  },
  lv: {
    loading: 'Notiek jūsu lietotņu ielāde…',
  },
  lt: {
    loading: 'Įkeliamos jūsų programėlės…',
  },
  mt: {
    loading: 'Qed jitgħabbew l-Applikazzjonijiet tiegħek…',
  },
  pl: {
    loading: 'Ładowanie Twoich aplikacji…',
  },
  pt: {
    loading: 'Carregando seus aplicativos…',
  },
  ro: {
    loading: 'Se încarcă aplicațiile tale…',
  },
  sk: {
    loading: 'Načítavajú sa vaše aplikácie…',
  },
  sl: {
    loading: 'Nalaganje vaših aplikacij…',
  },
  es: {
    loading: 'Cargando tus aplicaciones…',
  },
  sv: {
    loading: 'Laddar dina Appar…',
  },
};
export default copy;
